import { useEffect, useRef } from "react";
import { Category, ContextPage, EventType } from "../constants";
import { useTrackingEvent } from "./useTrackingEvent";

export const useBookingTracking = ({
  publicationId,
  establishmentId,
  enabled = true,
}) => {
  const { runtime, trackEvent } = useTrackingEvent();
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (!enabled) return undefined;
    if (hasTrackedRef.current) return undefined;
    if (!publicationId || !establishmentId) return undefined;

    hasTrackedRef.current = true;

    trackEvent({
      schemaVersion: runtime.schemaVersion,
      eventTime: new Date().toISOString(),
      category: Category.CONVERSION_EVENT,
      eventType: EventType.PREVIEW_VIEW,
      establishmentId,
      publicationId,
      visitorCountry: runtime.visitorCountry?.countryCode || undefined,
      context: { source: runtime.trackingSource, page: ContextPage.BOOKING },
    }).catch(() => {});
  }, [enabled, establishmentId, publicationId, runtime, trackEvent]);
};
